import { ReactElement, useEffect } from 'react';
import { useMutation } from 'react-query';

import { createErrorNotification } from '../../services/notification';
import useAuthStore from '../../store/useAuth';
import useFirebaseStore from '../../store/useFirebase';
import { getErrorMessage } from '../../utils/query';

function SCFirebaseManager(): ReactElement {
  const isLogged = useAuthStore((state) => state.isLogged);
  const setToken = useFirebaseStore((state) => state.setToken);
  const serviceWorker = useFirebaseStore((state) => state.serviceWorker);
  const getFirebaseToken = useFirebaseStore((state) => state.getFirebaseToken);

  const { mutate: getFirebaseTokenMutate } = useMutation(
    (serviceWorkerRegistration: ServiceWorkerRegistration) => getFirebaseToken(serviceWorkerRegistration),
    {
      onError: (error: Error) => createErrorNotification(getErrorMessage(error)),
      onSuccess: (token: string) => {
        setToken(token);

        return;
      },
    }
  );

  useEffect(() => {
    if (!isLogged) return;

    getFirebaseTokenMutate(serviceWorker);
  }, [getFirebaseTokenMutate, serviceWorker, isLogged]);

  return null;
}

export default SCFirebaseManager;
